// Active 出戰角色 selection (roguelite loadout). FRONTEND presentation/selection state,
// persisted to localStorage (mirrors the locale / equipped-cosmetic pattern). It feeds the
// sim ONLY a resolved Loadout (start weapon + passive) at match creation — never mutates a
// stat directly, never touches the wallet. Off-DOM (SSR/tests) it no-ops to the default char.
//
// Ownership gating: in single-player (offline) the full roster is selectable so the player can
// FEEL a pulled character change a match before real ownership is wired. When the backend flag is
// on (P1), Collection should gate selection to owned/unlocked characters. See
// docs/playability-monetization.md §2.

import { type Loadout, resolveLoadout } from '../sim/JKGame_pack'
import { isUnlocked } from './JKGame_souls'

const KEY = 'jkgame.activeChar'
const DEFAULT_CHAR = 'c_default'

let active: string = read()

function read(): string {
  try {
    return localStorage.getItem(KEY) || DEFAULT_CHAR
  } catch {
    return DEFAULT_CHAR // localStorage unavailable
  }
}

/** The character id the player will deploy with (defaults to the free starter). */
export function getActiveChar(): string {
  return active
}

export function setActiveChar(id: string): void {
  active = id
  try {
    localStorage.setItem(KEY, id)
  } catch {
    /* ignore */
  }
}

/** Resolve the active character's loadout for createMatch, or null (→ default player template).
 *  RNG-free; safe to pass straight into the deterministic sim. */
export function activeLoadout(): Loadout | null {
  // A character the player no longer has unlocked (or never did) deploys as the default
  // template — you can't field a locked character's start weapon/passive by stale selection.
  if (!isUnlocked(active)) return null
  return resolveLoadout(active)
}

/** The active character id to send to the backend match (it resolves the loadout server-side),
 *  or null when locked/unowned → backend uses the default template. Mirrors activeLoadout's gate. */
export function activeCharForBackend(): string | null {
  return isUnlocked(active) ? active : null
}
